var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoModelMgt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.944 1.904a2.395 2.395 0 01.719 4.68l-.002 1.242 3.132 1.809a.32.32 0 01.153.209l.007.067v3.403l.929.78c.4-.416.95-.688 1.563-.73l.164-.005a2.395 2.395 0 11-2.373 2.07l-.873-.733-3.26 1.883a.32.32 0 01-.257.028l-.062-.028-3.262-1.883-.765.644c.014.082.025.165.03.25l.006.163a2.395 2.395 0 11-.722-1.713l.862-.726.001-3.403a.32.32 0 01.105-.237l.055-.04 3.13-1.808V6.584a2.396 2.396 0 01-1.67-2.121l-.005-.164a2.395 2.395 0 012.395-2.395zM3.398 14.636a1.118 1.118 0 100 2.235 1.118 1.118 0 000-2.235zm13.21 0a1.118 1.118 0 100 2.235 1.118 1.118 0 000-2.235zM9.945 9.07L7.37 10.556v2.97l2.573 1.486 2.572-1.485v-2.97L9.944 9.07zm0-5.89a1.118 1.118 0 100 2.235 1.118 1.118 0 000-2.235z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoModelMgt);
export default __webpack_public_path__ + "static/assets/infoModelMgt.de36a67c.svg";
export { ForwardRef as ReactComponent };